import {mapGetters, mapActions, mapMutations} from 'vuex';
import {assign, cloneDeep} from "lodash";

export default {
  name: 'ordersNew',
  data() {
    return {
      currentAvailability: ''
    }
  },
  components: {},
  created() {
    if (!('page' in this.$route.query)) {
      this.setUrlParams({page: 1});
    } else {
      if (this.$route.query.availability) {
        this.currentAvailability = this.$route.query.availability;
      }
      this.setUrlParams();
      this.fetchNewOrders(this.$route.query);
    }
  },
  mounted() {},
  computed: {
    ...mapGetters({
      ordersNewAvailabilityStatuses: 'orders/ordersNewAvailabilityStatuses',
      ordersNewList: 'orders/ordersNewList',
      isOrdersNewLoading: 'orders/isOrdersNewLoading',
      ordersNewPage: 'orders/ordersNewPage',
      ordersNewPageLength: 'orders/ordersNewPageLength',
    }),
  },
  watch: {
    '$route.query': {
      handler: function (val) {
        if (val.page) {
          this.fetchNewOrders(this.$route.query);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      fetchNewOrders: 'orders/ORDERS_REQUEST_NEW_LIST_GET',
      deleteNewOrders: 'orders/ORDERS_REQUEST_NEW_ITEM_DELETE',
    }),
    isAvailability(item) {
      return item.products.data.every(item => {
        let count = item.on_store_count - item.reserved_count - item.order_count;
        return count >= 0;
      })
    },

    getClient(item) {
      return item.address
    },

    setUrlParams(query = {}) {
      let oldQuery = cloneDeep(this.$route.query);
      if ('availability' in query && query.availability.length === 0) {
        delete query.availability
        delete oldQuery.availability
      }

      this.$router.push({name: 'orders.list', query: assign({}, oldQuery, query)}).catch(() => {
        console.log()
      });
    },

    getPage(pageId) {
      this.setUrlParams({page: pageId})
    },

    changeAvailabilitStatus() {
      this.setUrlParams({
        page: 1,
        availability: this.currentAvailability,
      });
    },

    deleteItem(item) {
      this.deleteNewOrders(item.id).then(()=>{
        this.fetchNewOrders(this.$route.query).then(()=>{
          if (!this.ordersNewList.length && this.ordersNewPageLength > 1) {
            this.setUrlParams({page: this.ordersNewPageLength})
          }
        });
        this.$toasted.success(this.$t('orderDeleted'));
      }).catch(error => {
        if (error.response.status === 422) {
          this.$toasted.error(error.response.data.message);
        }
      });
    },

    show(item) {
      this.$router.push({name: 'orders.show', params: {orderId: item.id}}).catch(() => {console.log();});
    }

  },
  destroyed() {},
}
